"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchError = void 0;
// TODO: see if target is still provided in function calls
var catchError = function (ErrorClass) {
    return function logMethod(target, propertyName, propertyDesciptor) {
        var method = propertyDesciptor.value;
        var wrappedMethod = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var stringArgs = args.map(function (a) { return JSON.stringify(a); }).join();
            try {
                var result = method.apply(wrappedMethod, args);
                return result;
            }
            catch (e) {
                if (e instanceof ErrorClass) {
                    console.error(e);
                    throw new Error("Error ".concat(e, " was thrown by a call to ").concat(propertyName, " with arguments ").concat(stringArgs));
                }
                else {
                    throw e;
                }
            }
        };
        return __assign(__assign({}, propertyDesciptor), { value: wrappedMethod });
    };
};
exports.catchError = catchError;
//# sourceMappingURL=catchError.js.map